const config = {
    api_host_dev: process.env.REACT_APP_HOST_DEV,
    api_image: process.env.REACT_APP_HOST_IMAGE,
}

export { config };